/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ManualDisableYieldRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {ManualDisableYieldResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const manualDisableYield = (request: ManualDisableYieldRequest, options?: CashRequestOptions) => post<ManualDisableYieldRequest, ManualDisableYieldResponse>("/2.0/cash/manual-disable-yield", request, {...options, rejectOnError: true })